import { render, staticRenderFns } from "./AutoRankingPreferences.vue?vue&type=template&id=4a9e1d3e&scoped=true&lang=pug&"
import script from "./AutoRankingPreferences.vue?vue&type=script&lang=js&"
export * from "./AutoRankingPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9e1d3e",
  null
  
)

export default component.exports